import { z } from "zod"
import { MessageChannelSchema } from "./ScheduleMessageAsStoreStaff"

/**
 * A message to a store customer that isn't about a job. The recipient's phone
 * number and email are read from the store customer, not sent by the client.
 */
export const ScheduleMessageToStoreCustomerSchema = z.object({
  content: z.string().min(1),
  // multipart/form-data does not carry repeated values reliably, so the
  // channels arrive as a comma-separated string and are split back here.
  channels: z
    .string()
    .transform((value) => value.split(","))
    .pipe(MessageChannelSchema.array().min(1).max(2)),
  // multipart/form-data carries booleans as strings.
  sendFullSms: z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional(),
  // attachedFiles handled by multer, not in validation
})

export type ScheduleMessageToStoreCustomer = z.infer<
  typeof ScheduleMessageToStoreCustomerSchema
>

export const SendMessageAsStoreCustomerSchema = z.object({
  storeCustomerId: z.string().uuid(),
  content: z.string().min(1),
  // attachedFiles handled by multer, not in validation
})

export type SendMessageAsStoreCustomer = z.infer<
  typeof SendMessageAsStoreCustomerSchema
>
